import Swiper from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'

export class CoursePickupSlider {
  constructor() {
    if (document.querySelector('.js-course_pickup_slider') === null) return
    let options = {}
    const slider = document.querySelectorAll('.js-course_pickup_slider')
    for (let index = 0; index < slider.length; index++) {
      let slideList = slider[index].querySelectorAll('.swiper-slide')
      if (slideList.length > 1) {
        options = {
          loop: false,
          slidesPerView: 1.2,
          spaceBetween: 10,
          speed: 600,
          centeredSlides: false,
          breakpoints: {
            767: {
              slidesPerView: 3,
              spaceBetween: 40,
            },
          },
        }
        new Swiper('.js-course_pickup_slider', options)
      }
    }
  }
}
